<template>
    <div v-bind:class="{show : dialogueVisible == true, displayblock : dialogueVisible == true}" class="modal sustainable-component update-competence-comment" tabindex="-1" v-bind:id="'customModal' + getId()" role="dialog">
        <div class="modal-dialog" v-bind:class="size" role="document">
            <div class="modal-content">
                <div class="modal-header bg-primary">
                    Uppdatera
                </div>

                <div class="modal-body pb-0">
                    <div class="container-fluid p-0">
                        <div class="row">
                            <div class="col">
                                <v-text-field v-bind:disabled="disabled" bg-color="white" label="Kommentar" v-model="item.Comment" variant="outlined"></v-text-field>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <v-text-field v-bind:disabled="disabled" bg-color="white" type="date" label="Yrkets startdatum" v-model="item.ReminderDate" variant="outlined"></v-text-field>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer pt-2 pb-1">
                    <v-btn color="blue-darken-1"
                           variant="text"
                           @click="close">
                        Stäng
                    </v-btn>
                    <v-btn color="blue-darken-1"
                           variant="text"
                           @click="save">
                        Spara
                    </v-btn>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    //import WageService from "../../../Services/WageService";
    import { getCurrentInstance } from 'vue'
 
    export default {
        emits: ['updated'],
        name: 'update-competence-comment',
        props: {
            
        },
        methods: {
            getId() {
                return getCurrentInstance().uid;
            },
            close() {
                this.item = JSON.parse(this.tmpValue);
                this.dialogueVisible = false;
                this.thisModal.hide();
            },
            async save() {
                this.dialogueVisible = false;
                this.thisModal.hide();
                this.$emit("updated");  
            },
            open(item) {
                this.item = item;
                this.tmpValue = JSON.stringify(item);
                this.dialogueVisible = true;
                this.thisModal.show();
            },
        },
        data() {
            return {
                tmpValue: "",
                item: {Comment:"", ReminderDate : ""},
                dialogueVisible: false,
                thisModal: {},
            };
        },
        watch: {

        },
        mounted() {
            this.$el.remove();
            document.body.appendChild(this.$el);

            // eslint-disable-next-line
            this.thisModal = new bootstrap.Modal(document.getElementById('customModal' + this.getId()), {});

            //window.emitter.on('display_login', this.close);
        },
        // eslint-disable-next-line
        setup(props, { emit }) {}
    }
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .modal-content{
        border-radius:unset;
    }

    .modal-footer {
        border-top-color: transparent;
    }
    .modal-header {
        border-top-left-radius: unset;
        border-top-right-radius:unset;
    }
</style>
